// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__+Xznk","portfolioimage":"Portfolio_portfolioimage__J1BPx","portfoliodiv":"Portfolio_portfoliodiv__HDpDA"};